// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { subISOWeekYears as fn } from "../subISOWeekYears.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const subISOWeekYears = convertToFP(fn, 2);

// Fallback for modularized imports:
export default subISOWeekYears;
